import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { EnvironmentSettings } from "../enviroments/environment-settings";
import { AppSettings } from "../class/general-classes/app-settings";
import { environment } from "src/environments/environment";
import { ApplicationTheme } from "../enum/enumMisc";

@Injectable({
  providedIn: "root",
})
export class S3UploadService {
  private readonly _http = inject(HttpClient);


  /**
   * Get the list of folders
   * @returns
   */
  public async getFolders(theme: ApplicationTheme): Promise<any> {
    return this._http
      .get(
        EnvironmentSettings.API_ICON_REPOSITORY +
          "iconrepository/folders?theme=" +
          theme,
      )
      .toPromise();
  }

  /**
   * Get the list of files by folder
   * @param folder
   * @returns
   */
  public async getFilesByFolder(folder = ""): Promise<any> {
    let param = "";
    if (folder != "") {
      param = "?folder=" + folder;
    }

    return this._http
      .get(
        EnvironmentSettings.API_ICON_REPOSITORY +
          "iconrepository/files" +
          param,
      )
      .toPromise();
  }

  /**
   * Upload image to s3
   * @param file
   * @returns
   */
  public async uploadImage(file: File) {
    const formData = new FormData();
    formData.append("file", file);

    return this._http
      .post<string>(
        environment.httpServerRoot + AppSettings.API_URL_MEDIA + "/s3",
        formData,
      )
      .toPromise();
  }

  /**
   * Delete image in s3
   * @param fileName
   * @returns deletes file
   */
  public async deleteImage(fileName: string): Promise<string> {
    return this._http
      .delete<string>(
        environment.httpServerRoot +
          AppSettings.API_URL_MEDIA +
          "/s3?FileName=" +
          fileName,
      )
      .toPromise();
  }

  /**
   * Get the uploaded image from s3
   * @param fileName
   * @returns image as Blob object
   */
  public async getImage(fileName: string): Promise<Blob> {
    return this._http
      .get(
        environment.httpServerRoot +
          AppSettings.API_URL_MEDIA +
          "/s3?fileName=" +
          fileName,
        { responseType: "blob" },
      )
      .toPromise();
  }
}
